module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.724.406.303.47.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.0.0.box.724.406.303.47.q.90"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("PREFACE ")])])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.171.517.1412.2014.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.14.1.0.box.178.517.1405.467.q.60"
    }
  }, [_vm._v("WHEN friends suggested that I was the logi"), _c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.1.0"
    }
  }), _vm._v("cal one to write the history of my native parish, I responded that I was neither a writer nor a historian. Upon considering the idea more leisurely I decided that in Louisiana there is a close connection between history and languages. No one can go back to the eighteenth century in Louisiana history without a knowledge of French and Spanish. A century is not an insignificant item when we consider that our state is only a little more than twice that age, that is, the white race first settled in what is now Louisiana in 1714 or 1715.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.178.1026.1403.308.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.1.2.0"
    }
  }), _vm._v("The next step in my mind was to decide to undertake the task as a compiler, realizing that older and better posted citizens of Avoyelles Parish could contribute essays on special subjects. This plan did not succeed, for one has to be willing as well as competent and all my requests were answered in the negative, pleading lack of time, etc.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.174.1373.1405.626.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.2.0.0"
    }
  }), _vm._v("I then decided to do it myself and use the questionnaire method to collect data; but only about half of the questionnaires sent were answered. Undaunted, I then campaigned the parish to interview those who had been recommended as having dependable knowledge of the parish history. This proved to be a race with death. Two of the octogenarians I had planned to call on, passed away before my visit: Mrs. Julia Boyer of Moreauville, and Mrs. Thomas Overton of Alexandria. Those who died shortly after the interview were Dr. F. J. Perkins of Simmesport, Dr. S. J. Couvillon of Moreauville, Mr. Darius Mayeux of Plaucheville, Mr. Horace Rabalais of Cocoville, Mrs. Henry Gaines of New Orleans, Mrs. Penelope Heard of Evergreen.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.3.box.171.2037.1405.304.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.2.1.0"
    }
  }), _vm._v("This piece of research represents five years of work. I spent four weeks on an inventory of old documents in the archives of the Avoyelles Parish Courthouse, which had taken me two years to locate as the new officers did not know there were old documents in the courthouse. I also read the several volumes of police jury proceedings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP15.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.4.box.171.2382.1402.149.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP15.w.2.2.0"
    }
  }), _vm._v("I made several trips to New Orleans to see if there was any material on my subject in the archives of the Louisiana State Museum and at the Howard Memorial Library. I also went to the"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP16.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.1.0.box.171.277.1409.307.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.1.0.0"
    }
  }), _vm._v("\nlibrary of the Louisiana State University at Baton Rouge, and, of course, the library of the Louisiana State Normal College furnished a great deal of material on the subject. But when it came to the history of postoffices, I could find no material anywhere, so I went to Washington, since the employees were too busy to get the information for me and send it by mail.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP16"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.1.0.box.171.277.1438.2066.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP16.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.1.box.177.620.1421.1111.q.50"
    }
  }, [_vm._v("In spite of all the disappointments, I have enjoyed it and feel deeply grateful to all those who have helped me in any way. I wish to express my deep appreciation to Mr. Robert J. Usher and Miss Marguerite Renshaw of the Howard Memorial, now the HowardTilton Memorial Library; to Mr. James A. Macmillian, and Mrs. Ruth Campbell of the Louisiana State University Library; to Miss Scharlie Russell and her successor, Mr. Eugene Watson, and their staff, of the Louisiana State Normal College Library; to Mrs. H. Lorio of the Archives of the Louisiana State Museum, New Orleans; to all those in Avoyelles Parish who gave me information through the mail and in person. My special thanks go to Mr. Henry Bielkewitcz,"), _c('sup', [_vm._v("1")]), _vm._v(" Marksville's grand old man, who can say, \"This happened just one hundred years ago, I can remember it distinctly\"; Mrs. Annette Derivas de Nux of Marksville, who is as erect and alert at ninety as many a woman of fifty; Mr. C. P. Couvillon whose memory is as clear and accurate at eighty as it was at twenty; Mrs. J. P. Grimes, whose graciousness was a reward worth traveling many miles through muddy roads in order to interview her; James Villemarrette, affable clerk of court, and his capable deputy, Eugene Schwartsburg; my cousin, Superintendent L. A. Cayer, who was ever ready to give any information either verbally or in writing.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP16.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.1.2.box.194.1767.1415.576.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.1.2.0"
    }
  }), _vm._v("The information secured from interviews was used for part two of the book, since very little could be found on the subject in books. An effort was made to get dependable data and only those who were known to have that kind were interviewed. Among those interviewed were: Bordelonville, Edmond Tassin; Bunkie, Mrs. C. P. Taliaferro; Cent"), _c('a', {
    attrs: {
      "id": "GBS.PP16.w.2.0.0"
    }
  }), _vm._v("er Point, Mrs. J. P. Grimes and Dr. John Paul; Effie, W. H. Ryland, Postmaster; Eola, G. B. Hudson; Evergreen, Mrs. Penelope Ewell Heard (died June 6, 1940); Gold Dust, Mrs. C. K. White; Goudeau, Mrs. Ray Goudeau; Hamburg, Olivier Couvillon (died 1940); Hessmer, S. A. Bernard; Long Bridge, Mrs. B. B. Joffrion and J. P. Cazale; Mansura, Misses Bertha and Anna"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.16.1.0.box.201.293.1404.310.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP16.w.2.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.0.0"
    }
  }), _vm._v("\nPorterie; Marksville, C. P. Couvillon, Dr. Cilton Couvillon, Dr. W. F. Couvillon, Mrs. Annette Derivas de Nux, Mrs. Edgar Coco, Sr., and Mr. Henry Bielkewitcz; Moncla, Mr. L. E. Moncla; Moreauville, Dr. S. "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("J: ")]), _vm._v("Couvillon (died in 1938); Plaucheville, Edwin Ducote; Simmesport, N. Norwood (died 1939), and Dr. T. J. Perkins (died January 14, 1939); Vick, Mrs. W. H. Sayes.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.0.0.1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.1.0"
    }
  }), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.15.2.0.box.203.2394.1311.72.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP16.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote gtxt_list_entry",
    attrs: {
      "id": "para.15.2.0.box.203.2394.1311.72.q.50"
    }
  }, [_vm._v("1 Mr. Bielkewitcz passed away May 26, 1941, at the age of 107. It is said that thirty persons out of a million live to be 100 years old.")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.193.293.1412.2186.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.198.616.1406.580.q.60"
    }
  }, [_vm._v("For the third part of the book, excerpts were taken from biographical memoirs, showing the origin of the settlers. As for the photographs, in order to avoid the task of having to decide who should be given that space, there are so many who have served the parish loyally and. well that should have been included, but that would have made the volume longer that it was intended to be, so the idea of selecting only those who had been appointed or elected to serve the state came to my mind, and I decided to use the plan, as it seemed fair and simple. I tried to be impartial and if certain parts of the parish are given more attention than others, it is because I received more cooperation from the people of those sections.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.197.1210.1403.249.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.2.0"
    }
  }), _vm._v("The four pencil drawings (Catholic Church in Marksville, cotton gin, steamboat, and the Joffrion home in Marksville) were done by Mrs. Earle Horter, nee Elizabeth Lentz, art teacher in Philadelphia. The pen and ink drawings were done by Ben Watkins, art teacher in New Orleans.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.3.box.194.1477.1404.521.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.3.0"
    }
  }), _vm._v("The nature of the subject made it impossible to rely strictly on authentic sources; man's memory, however good it may be, is not always reliable. For instance, Dr. Cilton Couvillon says that Pierre Couvillon cleared up Bayou des Glaises of canebreaks with penitentiary labor; Dr. W. F. Couvillon says that it was done by another Couvillon. The Couvillons also disagree in regard to the spelling of their name. Some have retained the old way; others have dropped the last \"i\" since it is a silent letter. The correct spelling of names was next to impossible, because they are frequently misspelled on the records.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.4.box.193.2011.1403.307.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.4.0"
    }
  }), _vm._v("Of course, even supposedly reliable sources in book form are not always accurate. For instance, in "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Battles ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("and ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Leaders ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("of ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("the ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Civil ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("War ")]), _vm._v("in four volumes, I found the distance given between Fort de Russy and Alexandria as three miles. Anyone who has traveled this distance, as I have, by buggy, knows that it is at least forty miles, following the river.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP17.w.1.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.5.box.193.2332.1403.147.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP17.w.1.5.0"
    }
  }), _vm._v("I found other sources to have conflicting statements, including the records of the Police Jury, where passing upon matters of business did not always mean that they were put into execution.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP18"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.171.276.1413.552.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP18.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.0.box.172.276.1412.312.q.40"
    }
  }, [_vm._v("I wish to thank Mrs. Lizzie Carter McVoy, my former teacher, and Dr. Sarah L. C. Clapp, my friend and colleague, for having read between the two of them, the manuscript and offered valuable suggestions. I wish to acknowledge the assistance given by my three students, Frank J. Mobley, Adair Scherz, and Adele Spann, in typing the manuscript.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP18.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.1.1.box.171.627.1411.201.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP18.w.1.1.0"
    }
  }), _vm._v("Finally, I wish to say that this work is not a true history, in the sense of interpreting causes and effects of events; it is rather a recording of facts and has for its "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("raison ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("d'etre ")]), _vm._v("what the Spaniard calls his love for his "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("patria ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("chica. ")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.1.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP19"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.0.0.box.237.384.1316.1747.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_h1_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.18.0.0.box.757.384.187.44.q.80"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Errata ")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.1.box.243.520.884.43.q.50"
    }
  }, [_vm._v("Page 3, line 17: Les Francois en ont (on).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.2.box.243.600.902.42.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.2.0.0"
    }
  }), _vm._v("Page 25, line 36: two double-barreled guns.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.3.box.242.678.1025.43.q.70"
    }
  }, [_vm._v("Page 37, line 20: Santo Domingo (San Domingo).")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.4.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.4.box.244.759.955.40.q.40"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.3.0.0"
    }
  }), _vm._v("Page 76, line 3, add name of P. M. Gremillion.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.5.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.5.box.240.833.1239.44.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.4.0.0"
    }
  }), _vm._v("Page 127, last line, Kenneth McCruman instead of Kennth.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.6.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.6.box.240.913.1012.42.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.5.0.0"
    }
  }), _vm._v("Page 129, line 7, should be \"Perpetual Regidor\".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.7.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.7.box.244.992.878.40.q.70"
    }
  }, [_vm._v("Page 140, line 21, organization misspelled.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.8.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.8.box.241.1066.1308.93.q.60"
    }
  }, [_vm._v("Page 156, line 6, after \"election\" add: may be levied a"), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.5.1.0"
    }
  }), _vm._v("nd collected.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.9.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.9.box.241.1203.881.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.6.0.0"
    }
  }), _vm._v("Page 158, line 13, \"have\" should be \"has\".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.10.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.10.box.241.1282.858.41.q.60"
    }
  }, [_vm._v("Page 159, line 9, a fall of one half a foot.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.11.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.11.box.244.1360.1309.90.q.60"
    }
  }, [_vm._v("Page 202, last line on page, add \"Henrietta\" before M"), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.6.1.0"
    }
  }), _vm._v("rs. Julian Goudeau.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.12.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.12.box.244.1492.857.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.7.0.0"
    }
  }), _vm._v("Page 280, last line, Says should be Sayes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.13.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.13.box.243.1568.1284.40.q.60"
    }
  }, [_vm._v("Page 305, line 21, Washington Street should be Monroe Street.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.14.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.14.box.238.1647.1101.38.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.8.0.0"
    }
  }), _vm._v("Page 310, line 28, Harmonson should be Harmanson.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.15.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.15.box.237.1725.949.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.9.0.0"
    }
  }), _vm._v("Page 311, line 6, Marshall should be Marshal.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.16.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.16.box.237.1804.1128.40.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.10.0.0"
    }
  }), _vm._v("Page 315, line 8, stage line should be stage coach line.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.17.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.17.box.243.1884.1058.38.q.70"
    }
  }, [_vm._v("Page 332, line 35, put the name \"Paulin\" in blank.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.18.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.18.box.243.1961.1310.90.q.50"
    }
  }, [_vm._v("Page 428, line 20, Proposed: number? (for "), _c('a', {
    attrs: {
      "id": "GBS.PP19.w.10.1.0"
    }
  }), _vm._v("no.); line 26, cut off is, should be cut offs.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP19.w.0.19.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_list_entry",
    attrs: {
      "id": "para.18.0.19.box.243.2091.990.40.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP19.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP20"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP20.w.0.0.0"
    }
  }), _vm._v("Page 469, line 28, Gme. Cetoire (without and).")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0.2"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.1.0.0.3"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37af2f28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0010.vue
// module id = 60
// module chunks = 0